import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Check, Copy } from 'lucide-react';

import { Button, ButtonProps, toast } from '@codes/ui-kit';

interface CopyButtonProps {
    value: string;
    variant?: ButtonProps['variant'];
    size?: ButtonProps['size'];
}

export const CopyButton = ({ value, variant = 'ghost', size = 'icon' }: CopyButtonProps) => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(value);
            setCopied(true);
            toast({ description: t('workspace.setting.geminiApiKey.copySuccess') });

            timeoutRef.current = setTimeout(() => {
                setCopied(false);
            }, 2000);
        } catch (error) {
            toast({
                description: t('workspace.setting.geminiApiKey.copyError'),
                variant: 'destructive',
            });
        }
    };

    return (
        <Button variant={variant} size={size} onClick={handleCopy}>
            {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
        </Button>
    );
};
